<div class="page pt-2 pt-md-4">
    <div class="content-container extended">
        <div class="-ps-5 side-container mb-3">
            <div class="pt-0 position-relative">
                <pla-side-nav></pla-side-nav>
            </div>

            <div class="bg-light">
                <!-- <pla-featured-plates [featureType]="rsFeatured" [plateSize]="'smaller'" [priceFontSize]="16"
                    [maxCount]="10" [sortBy]="'price'" [plateClass]="'flat shaded'" [showIndex]="false"></pla-featured-plates> -->
            </div>
        </div>
        <div class="center-content-container position-relative">
            <div class="pla_card mobile spacing no-top no-card no-left no-right position-relative">
                <div>
                    <!-- BREADCRUMBS -->
                    <div class="w-100">
                        <div
                            class="border-bottom d-flex align-items-center justify-content-start gap-2 w-100 px-3 px-lg-0 pb-2 pt-0">
                            <a style="color: #327b8d" class="d-block text-decoration-none" [routerLink]="['/']">Home</a>
                            <span>/</span>
                            <a style="white-space: pre; color: #327b8d" class="text-decoration-none d-block"
                                [routerLink]="['/articles']">Resources</a>
                            <span>/</span>
                            <span style="color: #939393; white-space: pre" class="text-decoration-none d-block">Prefix
                                Number Plates</span>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="pla_card mobile spacing no-top no-card no-left no-right position-relative px-0 px-md-1 py-0 me-0">
                <div class="px-0 px-md-2">

                    <div class="mx-3 mx-md-0">

                        <div class="mt-4 mb-4 border-bottom border-2" style="border-color: #3791A8 !important;">
                            <p class="fs-mb-16 fs-md-18 fw-bold text-start mx-0">What is a Prefix Number Plates?</p>
                        </div>

                        <div class="mb-4">
                            <img src="https://cdn.platex.co.uk/pages/articles/lambo_murci.png" style="max-width: 500px"
                                class="mx-auto d-block w-100" />
                        </div>

                        <div>
                            <p class="fs-md-14 fs-mb-14 text-dark d-block mb-4">
                                Prefix registrations were introduced in the UK in 1983 and remained in use until 2001.
                                This system was implemented to replace the suffix system and provided a new way to
                                identify the age of vehicles. The prefix registration system involves a format where the
                                year identifier is placed at the beginning of the registration number.
                            </p>

                            <p class="fs-md-14 fs-mb-14 text-dark d-block mb-2">
                                Format:
                            </p>

                            <p class="fs-md-14 fs-mb-14 text-dark d-block mb-4">
                                Prefix Letter: A single letter indicating the year of registration (e.g., A, B, C,
                                etc.).
                                Numbers: Up to three numbers following the prefix letter (e.g., 123).
                                Letters: Three random letters at the end (e.g., ABC).
                                Example: A123 ABC
                            </p>

                            <p class="fs-md-14 fs-mb-14 text-dark d-block mb-2">
                                Key Characteristics:
                            </p>

                            <p class="fs-md-14 fs-mb-14 text-dark d-block mb-4">
                                Year Identifier: The prefix letter changes annually, starting with 'A' in 1983 and
                                proceeding alphabetically.
                                Sequential Numbers: Up to three numbers following the prefix letter.
                                Random Letters: Three letters at the end, providing a wide range of combinations.
                            </p>
                        </div>
                    </div>

                    <div style="height: 50px;"></div>

                    <div class="mx-3 mx-md-0">

                        <div class="mt-4 mb-4 border-bottom border-2" style="border-color: #3791A8 !important;">
                            <p class="fs-mb-16 fs-md-18 fw-bold text-start mx-0">Can You Use A Prefix Plate on Any
                                Vehicle</p>
                        </div>

                        <div>
                            <p class="fs-md-14 fs-mb-14 text-dark d-block mb-4">
                                Prefix plates do have a year identifier so they can only be added to a vehicle that was
                                manufacture in the same registration year or more recently. This is because it is
                                illegal to make a vehicle appear more new than it is.
                                There is information about the year of registration for each registration on the
                                individual plate information page along with price history where available.
                            </p>
                        </div>

                        <div class="mt-4 mb-4">
                            <img src="https://cdn.platex.co.uk/pages/articles/prefix_format.png"
                                style="max-width: 250px" class="mx-auto d-block w-100" />
                        </div>
                    </div>

                    <div style="height: 50px;"></div>

                    <div class="mx-3 mx-md-0">

                        <div class="mt-4 mb-4 border-bottom border-2" style="border-color: #3791A8 !important;">
                            <p class="fs-mb-16 fs-md-18 fw-bold text-start mx-0">Where to Find Prefix Number Plates</p>
                        </div>

                        <div>
                            <p class="fs-md-14 fs-mb-14 text-dark d-block mb-4">
                                All available prefix plates that match your searched word will be displayed when using
                                our super search. Alternatively you can see them displayed separately when using the
                                special <a href="/initials-search" class="text-decoration-underline"
                                    style="color: #3791A8;">initials search</a> or you can Build-Your-Own prefix
                                registration here;
                            </p>
                        </div>

                        <div class="mb-4">
                            <pla-byo-search-page [style]="'current'" [searchDefault]="false"
                                [inlineSearch]="true"></pla-byo-search-page>
                        </div>

                        <div>
                            <p class="fs-md-14 fs-mb-14 text-dark d-block mb-2">To start;</p>
                            <p class="fs-md-14 fs-mb-14 text-dark d-block mb-4">Enter the word or initials and leave the
                                remaining characters with a “?” to be freely allocated. You will notice that depending
                                on the style there location of the required numbers changes.</p>
                            <p class="fs-md-14 fs-mb-14 text-dark d-block mb-4">Note. Some letters are not available for
                                some series; I, O, Q Z are not available for the first letter of Prefix. Only certain
                                numbers have been released</p>
                        </div>
                    </div>

                    <div style="height: 50px;"></div>


                    <div class="mx-3 mx-md-0">

                        <div class="mt-4 mb-4 border-bottom border-2" style="border-color: #3791A8 !important;">
                            <p class="fs-mb-16 fs-md-18 fw-bold text-start mx-0">The Role of PlateX</p>
                        </div>

                        <div>
                            <p class="fs-md-14 fs-mb-14 text-dark d-block mb-4">
                                PlateX.co.uk is revolutionising the private plate market by improving transparency and
                                providing a free price comparison service. Similar to how Rightmove and Zoopla operate
                                in the property market, PlateX aggregates listings from multiple dealers, offering a
                                comprehensive view of the market.
                            </p>
                        </div>

                        <div>
                            <p class="fs-md-14 fs-mb-14 text-dark d-block mb-4">
                                Key Features of PlateX:
                            </p>
                        </div>

                        <div>
                            <p class="fs-md-14 fs-mb-14 text-dark d-block mb-4">
                                Comprehensive Listings: Aggregates private plate listings from various dealers.
                            </p>
                        </div>

                        <div>
                            <p class="fs-md-14 fs-mb-14 text-dark d-block mb-4">
                                Price Comparison: PlateCompare is a free service that compares prices across different
                                platforms, helping users find the best deals and reducing price discrepancies.
                            </p>
                        </div>

                        <div>
                            <p class="fs-md-14 fs-mb-14 text-dark d-block mb-4">
                                User-Friendly Interface: Simplifies the process of searching, buying, and selling
                                private plates.
                            </p>
                        </div>

                        <div>
                            <p class="fs-md-14 fs-mb-14 text-dark d-block mb-4">
                                By providing these services, PlateX.co.uk enhances transparency and liquidity in the
                                private plate market, benefiting both consumers and dealers.
                            </p>
                        </div>
                    </div>

                    <div style="height: 50px;"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="bg-light">
        <div class="content-container extended">
            <div class="blog-content-container position-relative py-3 mb-3 px-1 px-md-5">
                <p class="fw-bold mb-2 text-decoration-none d-block text-dark">In Other News</p>
                <pla-featured-blogs></pla-featured-blogs>
            </div>
        </div>
    </div>
</div>
